import { jwtDecode } from 'jwt-decode';

/** HR admin codes นอกเหนือจากฝ่าย HR/IT */
const BAIBOON_ADMIN_CODES = new Set(['012539', '001005']);

export function canManageBaiboon(emp) {
  if (!emp) return false;
  const org = emp.organization || {};
  return (
    org.level5 === 'ทรัพยากรบุคคล' ||
    org.level4 === 'เทคโนโลยีและสารสนเทศ' ||
    BAIBOON_ADMIN_CODES.has(String(emp.employeeCode || ''))
  );
}

export function findEmployeeBySession(session, employees = []) {
  if (!session || typeof session !== 'string' || !employees?.length) return null;

  let decoded;
  try {
    decoded = jwtDecode(session);
  } catch {
    return null;
  }

  return (
    employees.find(
      (employee) =>
        (employee.username && decoded?.initials && employee.username === decoded.initials) ||
        (employee.employeeCode && decoded?.UserCode && employee.employeeCode === decoded.UserCode) ||
        (employee.email &&
          decoded?.Email &&
          employee.email.replace(/\s/g, '').toLowerCase() === decoded.Email.replace(/\s/g, '').toLowerCase()) ||
        (employee.email &&
          decoded?.mail &&
          employee.email.replace(/\s/g, '').toLowerCase() === decoded.mail.replace(/\s/g, '').toLowerCase()) ||
        (employee.email &&
          decoded?.preferred_username &&
          employee.email.replace(/\s/g, '').toLowerCase() ===
            decoded.preferred_username.replace(/\s/g, '').toLowerCase()) ||
        (employee.email &&
          decoded?.userPrincipalName &&
          employee.email.replace(/\s/g, '').toLowerCase() ===
            decoded.userPrincipalName.replace(/\s/g, '').toLowerCase())
    ) || null
  );
}
